'use strict';

angular.module('shiftTraderApp')
    .controller('NewDayOffRequestCtrl', function ($scope, user, me, $rootScope, AvailabilityRules, UserPermissionsService,
                                                  SAErrorHandler, flash, Session, TimeService, $state, TempAppStorage, OverrideTokens) {
      $rootScope.$broadcast('setTopNavTitle', 'Days Off');
      $scope.me = me;
      $scope.user = user;

      var orgId = $scope.user.memberships[0].organization ? $scope.user.memberships[0].organization.id : $scope.user.memberships[0].organization_id;

      $scope.startOfWeekDay = Session.getStartOfWeekDay();
      $scope.dateToday = TimeService.getNowInStoreTime().toDate();
      $scope.workDayStartHour = Session.getWorkDayStartHour();

      $scope.requestBlackoutText = 'Request Day Off';

      $rootScope.$broadcast('setTopNavTitle', 'New Request for ' + $scope.user.name);


      var existingRequestData = TempAppStorage.get('daysOff.create');

      if (!_.isNull(existingRequestData)) {
        $scope.state = existingRequestData.request_state;
        $scope.newBlackoutDateData = existingRequestData.requestRawData;
      } else {
        $scope.newBlackoutDateData = {
          start_date: moment.utc().tz(Session.getTimezone()).hours(0).minutes(0).seconds(0).milliseconds(0).add(2, 'weeks').toDate(),
          end_date: moment.utc().tz(Session.getTimezone()).hours(0).minutes(0).seconds(0).milliseconds(0).add(2, 'weeks').toDate(),
          start_hour: $scope.workDayStartHour,
          end_hour: $scope.workDayStartHour
        };

        var d = TimeService.getBeginningOfDayFromDate(new Date), dd = TimeService.getBeginningOfDayFromDate(new Date);
        $scope.requestDaysAdv = $scope.user.memberships[0].organization.organization_config.num_days_request_advance;
        $scope.cannotRequestTwix = ($scope.requestDaysAdv) ? d.twix(dd.add($scope.requestDaysAdv, 'days')) : null;

        $scope.isSuperUser = false;
        $scope.overrideToken = null;
        OverrideTokens.getOne({ user_id: $scope.user.id, organization_id: orgId })
          .then(function(token) {
            $scope.overrideToken = token;
          }, function(response) {
            console.log('Failed to load override token', response);
          });

        $scope.state = {
          dayoffRequestType: '1',
          notInAdvanceEnough: false,
          showHides: {
            endDate: false,
            startTime: false,
            endTime: false
          },
          rawPermissions: null,
          derivedPermissions: null
        };
      }

      $scope.pickerOptions = {
        endTime: {
          interval: 60
        }
      };

    var permissionsToLookUp = [
      'days_off.add_message',
      'days_off.add_message_to_mine',
      'days_off.cancel_my_request',
      'days_off.remove',
      'days_off.approve',
      'days_off.disapprove',
      'days_off.request_for_other',
      'days_off.request_for_self',
      'days_off.create_override'
    ];

    function processRawPermissions() {
      var rawPerms = $scope.state.rawPermissions;
      var myReq = $scope.dayOff && $scope.dayOff.user && $scope.dayOff.user.id === $scope.me.id;

      $scope.state.derivedPermissions = {
        canSendMessage: rawPerms['days_off.add_message'] || myReq && rawPerms['days_off.add_message_to_mine'],
        canRemove: rawPerms['days_off.remove'],
        canCancel: rawPerms['days_off.cancel_my_request'],
        canApprove: rawPerms['days_off.approve'],
        canDisapprove: rawPerms['days_off.disapprove'],
        canRequestForOthers: rawPerms['days_off.request_for_other']
      };
    }

    UserPermissionsService.getCanDict(permissionsToLookUp, 'current')
      .then(function(dikt) {
        $scope.state.rawPermissions = dikt;

        $scope.isSuperUser = dikt['days_off.create_override'];

        processRawPermissions();
      });



      $scope.$watch('newBlackoutDateData.end_hour', function(hr) {
        console.log('newBlackoutDateData.end_hour', hr);
      });

      $scope.$watch('state.dayoffRequestType', function(val, oldVal) {
        console.log('$WATCH FIRED: state.dayoffRequestType', val, oldVal);

        if (val !== oldVal) {
          if (val == 1) {
            $scope.state.showHides = {
              endDate: false,
              startTime: false,
              endTime: false
            };

            $scope.newBlackoutDateData.end_date = moment($scope.newBlackoutDateData.start_date).add(1, 'days').toDate();
            $scope.newBlackoutDateData.start_hour = $scope.workDayStartHour;
            $scope.newBlackoutDateData.end_hour = $scope.workDayStartHour;
          } else if (val == 2) {
            $scope.state.showHides = {
              endDate: false,
              startTime: true,
              endTime: true
            };

            $scope.newBlackoutDateData.end_date =  moment($scope.newBlackoutDateData.start_date).toDate();
            $scope.newBlackoutDateData.start_hour = $scope.workDayStartHour;
            $scope.newBlackoutDateData.end_hour = $scope.workDayStartHour + 8;
          } else if (val == 3) {
            $scope.state.showHides = {
              endDate: true,
              startTime: false,
              endTime: false
            };

            $scope.newBlackoutDateData.end_date = moment($scope.newBlackoutDateData.start_date).add(2, 'days').toDate();
            $scope.newBlackoutDateData.start_hour = $scope.workDayStartHour;
            $scope.newBlackoutDateData.end_hour = $scope.workDayStartHour;
          } else if (val == 4) {
            $scope.state.showHides = {
              endDate: true,
              startTime: true,
              endTime: true
            };
          }

        }

      });

      var calculateTimes = function() {
        return {
          start_time_minutes: $scope.newBlackoutDateData.start_hour * 60,
          end_time_minutes: $scope.newBlackoutDateData.end_hour * 60
        };
      };

      $scope.$watch('newBlackoutDateData.start_date', function(start_date) {
        if ($scope.state.dayoffRequestType == 1) {
          $scope.newBlackoutDateData.end_date = moment(start_date).add(1, 'days').toDate();//.format('YYYY-MM-DD');
        }

        if ($scope.state.dayoffRequestType == 2) {
          $scope.newBlackoutDateData.end_date = moment(start_date).toDate();//format('YYYY-MM-DD');
        }

        if ($scope.state.dayoffRequestType == 3 || $scope.state.dayoffRequestType == 4) {
          if (moment($scope.newBlackoutDateData.start_date).dayOfYear() >= moment($scope.newBlackoutDateData.end_date).dayOfYear()) {
            $scope.newBlackoutDateData.end_date = moment($scope.newBlackoutDateData.start_date).add(2, 'days').toDate();//).format('YYYY-MM-DD');
          }
        }
      });

      var getCurrentRange = function() {
        var processedMinutes = calculateTimes();
        var start = TimeService.getBeginningOfDayFromDate(moment($scope.newBlackoutDateData.start_date));
        start = start.minutes(processedMinutes.start_time_minutes);
        var end = TimeService.getBeginningOfDayFromDate(moment($scope.newBlackoutDateData.end_date));
        end = end.minutes(processedMinutes.end_time_minutes);

        if ($scope.state.dayoffRequestType == 3) {
          end = end.add(1, 'days');
        }

        return start.twix(end);
      };

      var getAvailRuleDateText = function(rule) {
        if ($scope.state.dayoffRequestType == 1) {
          return rule.start.format('MMMM Do');
        } else if ($scope.state.dayoffRequestType == 3) {
          return rule.start.format('MMM Do') + ' through ' + moment(rule.end).subtract(12, 'hours').format('MMM Do');
        } else {
          // Line below gives EXACT request dates, hours (but, the end date won't match the End Date above)
          return rule.$minimalIntervalTimeFormat();
        }
      };

      var lastValidatedRange;
      $scope.validateDate = function() {
        $scope.requestBlackoutText = '';

        var now = moment.utc().unix();
        var processedMinutes = calculateTimes();
        var currentRange = getCurrentRange();

        $scope.state.notInAdvanceEnough = $scope.requestDaysAdv && $scope.cannotRequestTwix.overlaps(currentRange);

        if (!_.isUndefined(lastValidatedRange) && !lastValidatedRange.equals(currentRange)) {
          $scope.state.scheduleOverlapsWithRequest = false;
          $scope.overlappingWorkPeriods = [];
        }
        lastValidatedRange = currentRange;

        var orgId = $scope.user.memberships[0].organization ? $scope.user.memberships[0].organization.id : $scope.user.memberships[0].organization_id;

        var data = {
          user_id: $scope.user.id,
          organization_id: orgId,
          recurring: false,
          repeats_on_weekly: 0,
          avail: false,
          start_date: currentRange.start.format('YYYY-MM-DD'),
          start_time_minutes: processedMinutes.start_time_minutes,
          end_time_minutes: processedMinutes.end_time_minutes,
          end_date: currentRange.end.format('YYYY-MM-DD'),
          day_of_week: currentRange.start.day(),
          comment: $scope.newBlackoutDateData.comment
        };

        var newDayOff = AvailabilityRules.initWithData(data);
        $scope.submitButtonCounts = newDayOff.$getNumberOfFullAndPartialDays();

        $scope.currentDayoffAsText = getAvailRuleDateText(newDayOff);

        if ($scope.newBlackoutDateData.start_date === '') {
          // if start_date is not set, invalidate
          $scope.requestBlackoutText = 'Select A Date Range';
          $scope.state.dateRangeIsValid = false;
          return false;
        } else {
          var start_date = currentRange.start.unix();
          // verify that the start_date is before now, otherwise invalidate
          if (start_date < now) {
            $scope.requestBlackoutText = 'Select A Future Day';
            $scope.state.dateRangeIsValid = false;
            return false;
          }

          if (start_date >= currentRange.end.unix()) {
            $scope.requestBlackoutText = 'End Date must be the same as or after Start Date';
            $scope.state.dateRangeIsValid = false;
            return false;
          }

          var latestAllowedStartDate;
          if ($scope.user.$curMemb().organization.organization_config.dayoff_max_days_from_now === 0 ||
            ($scope.state.derivedPermissions && $scope.state.derivedPermissions.canRequestForOthers)) {
            latestAllowedStartDate = moment().add(1, 'years');
          } else {
            latestAllowedStartDate = moment().add($scope.user.$curMemb().organization.organization_config.dayoff_max_days_from_now, 'days');
          }
          if (start_date > latestAllowedStartDate.unix()) {
            $scope.requestBlackoutText = 'You are not allowed to request days off more than ' + $scope.user.$curMemb().organization.organization_config.dayoff_max_days_from_now + ' days in the future. Your request has to start on or before ' + latestAllowedStartDate.subtract(1, 'day').format('MMM D, YYYY') + '. Ask your manager to put in this request.';
            $scope.state.dateRangeIsValid = false;
            return false;
          }

          if ($scope.state.notInAdvanceEnough && !$scope.overrideToken && !$scope.isSuperUser) {
            $scope.requestBlackoutText = 'Your request must be submitted at least ' + $scope.requestDaysAdv + ' days prior.';
            $scope.state.dateRangeIsValid = false;
            return false;
          }

          if ($scope.state.notInAdvanceEnough && $scope.overrideToken) {
            $scope.requestBlackoutText = 'You have been granted an override token and can make this request within the restricted range.';
          }
        }
        //$scope.requestBlackoutText = 'Pick your date to request off';
        $scope.state.dateRangeIsValid = true;
        return true;
      };

    $scope.goToCreate = function() {
      var processedMinutes = calculateTimes();

      var theTwix = getCurrentRange();
      var start_date = theTwix.start;
      var end_date = theTwix.end;

      var orgId = $scope.user.memberships[0].organization ? $scope.user.memberships[0].organization.id : $scope.user.memberships[0].organization_id;
      var data = {
        requestData: {
          user_id: $scope.user.id,
          organization_id: orgId,
          recurring: false,
          repeats_on_weekly: 0,
          avail: false,
          start_date: start_date.format('YYYY-MM-DD'),
          start_time_minutes: processedMinutes.start_time_minutes,
          end_date: end_date.format('YYYY-MM-DD'),
          end_time_minutes: processedMinutes.end_time_minutes,
          day_of_week: start_date.day(),
          comment: $scope.newBlackoutDateData.comment
        },
        range_twix: theTwix,
        request_state: $scope.state,
        requestRawData: $scope.newBlackoutDateData
      };

      TempAppStorage.set('daysOff.create', data, 30);
      $state.go('^.create');
    };

    });
